import { getData, postData, putData } from '@/utils/api';
import { ApiResponse, RequestOptions } from '@/types/api';
import {
  GoalApiModel,
  GoalsApiModel,
  GoalsPagingApiModel,
  GoalCreateDataModel,
  GoalUpdateDataModel
} from '@/types/goals';

/**
 * 現在の目標を取得
 */
export async function getCurrentGoal(options?: RequestOptions): Promise<ApiResponse<GoalApiModel>> {
  const apiPath = `goals/current/`;

  return await getData<GoalApiModel>(apiPath, options);
}

/**
 * 目標一覧を取得
 */
export async function getGoals(
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<GoalsApiModel>> {
  const apiPath = `goals/?limit=${limit}&offset=${offset}`;
  return await getData<GoalsApiModel>(apiPath, options);
}

/**
 * 目標一覧を取得(ページング形式)
 */
export async function getGoalsPaging(
  pageNumber?: number,
  options?: RequestOptions
): Promise<ApiResponse<GoalsPagingApiModel>> {
  const queryParams = pageNumber ? `?page=${String(pageNumber)}` : '';

  const apiPath = `goals/paging/${queryParams}`;

  return await getData<GoalsPagingApiModel>(apiPath, options);
}

/**
 * 新しいの目標の作成
 */
export async function createGoal(
  formData: GoalCreateDataModel,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `goals/`;

  return await postData<void>(apiPath, csrftoken, formData, options);
}

/**
 * 目標の内容更新
 */
export async function updateGoal(
  formData: GoalUpdateDataModel,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `goals/${formData.id}/`;

  return await putData<void>(apiPath, csrftoken, formData, options);
}

/**
 * 目標のリアクティベート
 */
export async function reactivateGoal(
  goalId: number,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `goals/${goalId}/reactivate/`;

  return await putData<void>(apiPath, csrftoken, options);
}
